import { skipToken, useQuery } from '@tanstack/react-query'
import { agentsApi } from '../api/agents-api'
import { agentKeys } from '../api/query-keys'

const offlineAgentRefreshIntervalMs = 5000

export function useAgentDetail(entityId: string | null, agentId: string | null) {
  return useQuery({
    refetchOnWindowFocus: 'always',
    refetchOnMount: 'always',
    refetchInterval: (query) => {
      const detail = query.state.data
      return detail && !detail.agent.online && !detail.agent.revokedAt && !detail.decommissionedAt
        ? offlineAgentRefreshIntervalMs
        : false
    },
    refetchIntervalInBackground: false,
    queryKey: agentKeys.detail(entityId ?? '', agentId ?? ''),
    queryFn:
      entityId === null || agentId === null
        ? skipToken
        : () => agentsApi.getEntityAgentDetail(entityId, agentId),
  })
}
